import PropTypes from 'prop-types';
import CustomModal from 'commons/modal/CustomModal';
import React from 'react';
import HotFolder from '../HotFolder';

export default function HotFolderModal(props) {
  return (
    <CustomModal
      width={'50%'}
      title="Ajouter un document"
      onClose={props.onClose}
      body={<HotFolder params={props.params} numeric={props.numeric} onSave={props.onSave} camp_num={props.camp_num} showForm={props.showForm} />}
    />
  );
}

HotFolderModal.propTypes = {
  onClose: PropTypes.any,
  onSave: PropTypes.any,
  params: PropTypes.any,
  numeric: PropTypes.bool,
  camp_num: PropTypes.any,
  showForm: PropTypes.bool
};
